/**
 * MCP discovery / invoke client (A-0008.07).
 *
 * Calls Mind directly through Envoy (`/api/projecto/config/...` — edge JWT +
 * injected x-api-key; same transport every Platform→Engine call uses). Hits
 * Mind's config-mode endpoints `/v1/mcp/discover` and `/v1/mcp/invoke`.
 */
import {
 projectOService
} from './projectOProxy.service';
import {
    MCPDiscoverRequest,
    MCPDiscoverResponse,
    MCPInvokeRequest,
    MCPInvokeResponse,
} from '../bexService.types';

const MCP_DISCOVER_ENDPOINT = 'projecto/config/api/v1/mcp/discover';
const MCP_INVOKE_ENDPOINT = 'projecto/config/api/v1/mcp/invoke';

class MCPDiscoveryService {
    async discover(payload: MCPDiscoverRequest): Promise<MCPDiscoverResponse> {
        const data = await projectOService.performRequest(MCP_DISCOVER_ENDPOINT, {
            method: 'POST',
            data: payload as any,
            timeout: 60000,
        });
        return data as MCPDiscoverResponse;
    }

    async invoke(payload: MCPInvokeRequest): Promise<MCPInvokeResponse> {
        const data = await projectOService.performRequest(MCP_INVOKE_ENDPOINT, {
            method: 'POST',
            data: payload as any,
            timeout: 120000,
        });
        return data as MCPInvokeResponse;
    }
}

export const mcpDiscoveryService = new MCPDiscoveryService();
export default mcpDiscoveryService;
